import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  form: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
    RePassword: ['', Validators.required],
  })

  errorMessage: string = "";

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) { }
  ngOnInit(): void {
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }
    if (this.form.value.password != this.form.value.RePassword) {
      this.errorMessage = "A megadott két jelszó nem egyezik.";
      return;
    }
    this.authService.register(this.form.value.username, this.form.value.password).subscribe(success => {
      if (success) {
        this.router.navigate(['/calendar']);
      } else {
        this.errorMessage = "Sikertelen regisztráció. Lehet, hogy ez a felhasználó már létezik.";
      }
    }, error => {
      console.log(error);
      this.errorMessage = "Hiba történt kommunkikáció során.";
    });
  }

}
